import { VendorApiModel } from './vendor-api-model';

export class VendorModel {
    public VendorID:number;
    public  VendorName:string;
    public VendorAutoID:number;
   public VendorAutoComplete:any;
   public Vendorlist:VendorApiModel[];
}
